
export function verifyPermission(user, item){
    const {display} = item;
    const {role} = user;

   if(role.permissions[display]?.viewAll) return true;
   return false;

}
